import { authenticatedApi } from '../api';

const API_GRAPH_GLOBALS_PATH = '/graph/globals';

export const fetchGraphGlobals = async () => authenticatedApi.get(`${API_GRAPH_GLOBALS_PATH}`);
